<app-tile-list [tiles]="pathTypeTiles" (tileClicked)="tileClicked.emit($event)"></app-tile-list>
